import React, { useState, useEffect } from "react";




const CabinetHingesInstallation = () => {
  return (
   <div>
    <h2>
        hello
    </h2>
   </div>
  );
};



export default CabinetHingesInstallation;